import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import PrivacyContent from "@/components/legal/PrivacyContent";
import wealthyStewardLogo from "@/assets/wealthy-steward-logo.png";

const Privacy = () => {
  const navigate = useNavigate();
  const canGoBack = typeof window !== "undefined" && window.history.length > 1;

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src={wealthyStewardLogo}
              alt="Wealthy Steward"
              className="h-12 w-auto"
            />
          </Link>
          {canGoBack && (
            <Button
              variant="ghost"
              className="gap-2"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </Button>
          )}
        </div>
      </header>
      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <PrivacyContent />
      </main>
    </div>
  );
};

export default Privacy;
